import { createAction, props } from '@ngrx/store';
import { ContentGroupFilterV2ApiModel } from '@cxb/editor-stb-api';
import { ContentGroupFilterValueApiModel, ContentGroupPreviewV2ApiModel, ContentGroupV2ApiModel } from '@cxb/editor-stb-api/model/models';

const feature = '[Tenant independent Content-group edit screen]';

export const startLoadingEditScreen = createAction(`${feature} Loading edit screen started`);
export const finishLoadingEditScreen = createAction(`${feature} Loading edit screen finished`);

export const setContentGroup = createAction(`${feature} set Content-group`, props<{ contentGroup: ContentGroupV2ApiModel }>());
export const startLoadingPreview = createAction(`${feature} Loading preview start`);
export const finishLoadingPreview = createAction(`${feature} Loading preview finish`);
export const startLoadingSearch = createAction(`${feature} Loading preview start`);
export const finishLoadingSearch = createAction(`${feature} Loading preview finish`);
export const fetchContentGroupFail = createAction(`${feature} Content-group fetch fail`, props<{ errorMessage: string }>());
export const setOriginContentGroupFilter = createAction(
  `${feature} Set original content-group filters`,
  props<{ originContentGroupFilter: Array<ContentGroupFilterV2ApiModel> }>()
);
export const setCurrentContentGroupFilter = createAction(
  `${feature} Set active content-group filters`,
  props<{ currentContentGroupFilter: Array<ContentGroupFilterV2ApiModel> }>()
);
export const setOriginPinnedItems = createAction(`${feature} Set original pinned items`, props<{ originPinnedItems: Array<string> }>());
export const setOriginIsDynamic = createAction(`${feature} Set original isDynamic`, props<{ originIsDynamic: boolean }>());
export const setIsDynamic = createAction(`${feature} Set content-group isDynamic`, props<{ isDynamic: boolean }>());
export const setContentGroupFilters = createAction(
  `${feature} Set content-group filters`,
  props<{ filters: Array<ContentGroupFilterV2ApiModel> }>()
);
export const resetContentGroupEditScreenState = createAction(`${feature} Content-group state reset`);
export const setContentGroupAvailableFilterOptions = createAction(
  `${feature} Set available filter options`,
  props<{ availableFilterOptions: Array<ContentGroupFilterValueApiModel> }>()
);
export const updateContentGroupMeta = createAction(`${feature} Content-group update meta`, props<{ title: string; description: string }>());
export const setIsFilterFormValid = createAction(`${feature} set filter form validity`, props<{ isFilterFormValid: boolean }>());

export const setContentGroupPrograms = createAction(
  `${feature} Set content-group preview programs`,
  props<{ programs: Array<ContentGroupPreviewV2ApiModel> }>()
);

export const setSearchedPrograms = createAction(
  `${feature} Content-group set program search`,
  props<{ programs: Array<ContentGroupPreviewV2ApiModel> }>()
);
export const setPinnedContentIds = createAction(`${feature} Content-group pinned content ids set`, props<{ contentIds: Array<string> }>());
export const addPinnedContentId = createAction(`${feature} Content-group pinned content ids add`, props<{ contentId: string }>());
export const deletePinnedContentId = createAction(`${feature} Content-group pinned content ids delete`, props<{ contentId: string }>());
